import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const LINKS = [
  { label: 'Overview', href: '#overview' },
  { label: 'Curriculum', href: '#curriculum' },
  { label: 'Tools', href: '#tools' },
  { label: 'Projects', href: '#projects' },
  { label: 'Placement', href: '#placement' },
  { label: 'Certificates', href: '#certificates' },
  { label: 'Fees', href: '#fees' },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className={`fixed top-0 inset-x-0 z-50 transition-all ${
        scrolled ? 'bg-white/85 backdrop-blur-md border-b border-line' : 'bg-transparent'
      }`}
    >
      <div className="container-x flex items-center justify-between h-[72px]">
        <a href="#top" className="flex items-center gap-2">
          <img
            src="https://customer-assets-4nw71qhi.emergentagent.net/job_ai-analytics-site/artifacts/sk6qr2y3_ExcellenC%20logo%20May%2017%202025.png"
            alt="ExcellenC"
            className="h-10 md:h-11 w-auto"
          />
        </a>

        <ul className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="text-[15px] font-medium text-[color:var(--ink)] hover:text-red transition-colors"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#fees"
          className="hidden md:inline-flex items-center gap-2 bg-red text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:brightness-95 transition"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-white/90 animate-pulse" />
          Enquire Now
        </a>

        <button
          className="lg:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          <div className="w-6 h-0.5 bg-navy mb-1.5" />
          <div className="w-6 h-0.5 bg-navy mb-1.5" />
          <div className="w-6 h-0.5 bg-navy" />
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-line">
          <div className="container-x py-4 flex flex-col gap-3">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[15px] font-medium text-[color:var(--ink)] py-1"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#fees"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 bg-red text-white px-5 py-3 rounded-full text-sm font-semibold"
            >
              Enquire Now
            </a>
          </div>
        </div>
      )}
    </motion.nav>
  );
}
